import { useEffect } from 'react'

import { useDispatch, useSelector } from 'react-redux'
import clsx from 'clsx'

import { setUploadError, setUploadProgressData } from 'app/redux/messages/messages.actions'
import Styles from './UploadHints.module.scss'

const getUploadProgressData = ({ messagesData }) => messagesData.messages.uploadProgressData
const getUploadError = ({ messagesData }) => messagesData.messages.uploadError
const getTexts = ({ widgetData }) => widgetData.widgetInfo.languageInfo.texts

function UploadHints() {
  const uploadProgressData = useSelector(getUploadProgressData)
  const uploadError = useSelector(getUploadError)
  const texts = useSelector(getTexts)
  const dispatch = useDispatch()

  function getUploadText({ fileType, uploadPerc }) {
    const uploadText = fileType === 'image' ? texts.uploadLoadingImage : texts.uploadLoadingFile

    return `${uploadText} ${uploadPerc} %`
  }

  useEffect(() => {
    if (uploadProgressData?.percentage) {
      if (Number(uploadProgressData.percentage) === 100) {
        dispatch(setUploadProgressData({ fileType: null, percentage: null }))
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uploadProgressData?.percentage])

  useEffect(() => {
    if (uploadError) {
      setTimeout(() => {
        dispatch(setUploadError(''))
      }, 4000)
    }
  }, [uploadError])

  const shouldRender = uploadProgressData?.percentage !== null || !!uploadError

  if (!shouldRender) return null

  return (
    <div className={Styles.upload_hints}>
      <div
        className={clsx(
          Styles.upload_error_wrapper,
          uploadError ? Styles.show_upload_error_hint : Styles.hide_upload_error_hint,
        )}
      >
        {uploadError}
      </div>

      <div
        className={clsx(
          Styles.upload_progress_wrapper,
          uploadProgressData.percentage !== null ? Styles.show_upload_perc_hint : Styles.hide_upload_perc_hint,
        )}
      >
        {getUploadText({
          fileType: uploadProgressData.fileType,
          uploadPerc: uploadProgressData.percentage,
        })}
      </div>
    </div>
  )
}

export default UploadHints
